import React from 'react';
import { Box, Flex, HStack, Icon, Text, VStack } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';
import { FiShield } from 'react-icons/fi';
import { MONEY_BACK_GUARANTEE } from './homePageContent';

const shimmer = keyframes`
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
`;

export function MoneyBackGuaranteeStrip() {
	return (
		<Box
			position='relative'
			overflow='hidden'
			bg='linear-gradient(90deg, #064e3b 0%, #0d4f4f 50%, #0a2247 100%)'
			borderY='1px solid'
			borderColor='whiteAlpha.200'
			py={{ base: 4, md: 5 }}
			px={4}>
			<Box
				position='absolute'
				inset={0}
				bg='linear-gradient(105deg, transparent 40%, rgba(34,211,238,0.12) 50%, transparent 60%)'
				animation={`${shimmer} 4s ease-in-out infinite`}
				pointerEvents='none'
				aria-hidden
			/>
			<Flex
				maxW='container.xl'
				mx='auto'
				align='center'
				justify='center'
				gap={{ base: 3, md: 5 }}
				flexWrap='wrap'
				textAlign={{ base: 'center', md: 'left' }}
				position='relative'
				zIndex={1}>
				<Flex
					w={12}
					h={12}
					rounded='xl'
					bg='whiteAlpha.200'
					align='center'
					justify='center'
					flexShrink={0}>
					<Icon as={FiShield} boxSize={6} color='cyan.200' />
				</Flex>
				<VStack align={{ base: 'center', md: 'start' }} spacing={0} flex={1}>
					<Text
						fontWeight='extrabold'
						color='white'
						fontSize={{ base: 'md', md: 'lg' }}
						mb={0}
						letterSpacing='tight'>
						{MONEY_BACK_GUARANTEE.title}
					</Text>
					<Text color='whiteAlpha.800' fontSize='sm' mb={0} maxW='2xl'>
						{MONEY_BACK_GUARANTEE.description}
					</Text>
				</VStack>
				<Box
					display={{ base: 'none', lg: 'block' }}
					px={4}
					py={2}
					rounded='full'
					border='1px solid'
					borderColor='cyan.300'
					bg='whiteAlpha.100'>
					<Text fontSize='xs' fontWeight='bold' color='cyan.200' mb={0} textTransform='uppercase' letterSpacing='wider'>
						Risk-free purchase
					</Text>
				</Box>
			</Flex>
		</Box>
	);
}

export function MoneyBackGuaranteeBadge() {
	return (
		<HStack
			spacing={2}
			bg='green.500'
			color='white'
			px={4}
			py={2}
			rounded='full'
			boxShadow='0 4px 20px rgba(72, 187, 120, 0.35)'
			border='1px solid'
			borderColor='green.300'>
			<Icon as={FiShield} boxSize={4} />
			<Text fontSize='sm' fontWeight='bold' mb={0}>
				{MONEY_BACK_GUARANTEE.title}
			</Text>
		</HStack>
	);
}
